export function getStepFromPath(path) {
  const regex = /^\/([0-9]+)$/;
  const found = path.match(regex);
  if (found && found[1]) {
    return parseInt(found[1]);
  }
  return 0;
}

export function nextStepFromPath(path, statusSteps) {
  const nextIndex = getStepFromPath(path) + 1;
  if (nextIndex < statusSteps.length) {
    return `/${nextIndex.toString()}`;
  }
  return "/result";
}

export function previousStepFromPath(path) {
  const currentStep = getStepFromPath(path);
  if (currentStep - 1 > 0) {
    return `/${(currentStep - 1).toString()}`;
  }
  return "/";
}
